import { Phone, ArrowRight, CheckCircle2, ShieldCheck } from "lucide-react";
import { CONTACT, HERO_IMAGE } from "@/data/content";

const highlights = ["Trained Professionals", "Eco-Friendly Products", "Customized Programs", "Background-Checked Staff"];

export const Hero = () => {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-[92vh] flex items-center pt-20 overflow-hidden">
      <div className="absolute inset-0">
        <img src={HERO_IMAGE} alt="Commercial facility" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#1c4f9c]/85" />
        <div className="absolute inset-0 grain-overlay opacity-[0.15] mix-blend-overlay" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-20 w-full">
        <div className="max-w-3xl">
          <p className="animate-fade-up text-sm font-bold uppercase tracking-[0.2em] text-[#ff6b70] mb-5">
            Professional Commercial Cleaning
          </p>
          <h1 className="animate-fade-up text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white leading-[1.05]" style={{ animationDelay: "0.1s" }}>
            <span className="block">Elite Commercial</span>
            <span className="block">Cleaning Service</span>
          </h1>
          <p className="animate-fade-up mt-6 text-lg text-blue-100/90 leading-relaxed max-w-2xl" style={{ animationDelay: "0.2s" }}>
            Reliable, high-quality commercial cleaning, janitorial services & facility maintenance for offices, medical, educational, retail, industrial and new construction projects across Florida.
          </p>

          <div className="animate-fade-up mt-6 flex flex-wrap items-center gap-x-3 gap-y-2 text-sm font-semibold text-white" style={{ animationDelay: "0.25s" }} data-testid="hero-trust-line">
            <span className="flex items-center gap-2"><ShieldCheck size={16} className="text-[#ff6b70]" /> Locally Owned</span>
            <span className="text-blue-300">•</span>
            <span className="flex items-center gap-2"><ShieldCheck size={16} className="text-[#ff6b70]" /> Fully Insured &amp; Bonded</span>
            <span className="text-blue-300">•</span>
            <span className="flex items-center gap-2"><ShieldCheck size={16} className="text-[#ff6b70]" /> Free On-Site Estimates</span>
          </div>

          <div className="animate-fade-up mt-9 flex flex-col sm:flex-row gap-4" style={{ animationDelay: "0.3s" }}>
            <a
              href="#contact"
              data-testid="hero-estimate-btn"
              className="inline-flex items-center justify-center gap-2 bg-[#e02329] text-white font-bold py-4 px-8 rounded-sm hover:bg-[#c81e24] transition-colors duration-200"
            >
              Request a Free Estimate Today
              <ArrowRight size={18} strokeWidth={2.5} />
            </a>
            <a
              href={CONTACT.phoneHref}
              data-testid="hero-call-btn"
              className="inline-flex items-center justify-center gap-2 border-2 border-white/70 text-white font-bold py-4 px-8 rounded-sm hover:bg-white hover:text-[#1c4f9c] transition-colors duration-200"
            >
              <Phone size={18} strokeWidth={2.5} /> Call {CONTACT.phone}
            </a>
          </div>

          <div className="animate-fade-up mt-12 grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-2xl" style={{ animationDelay: "0.4s" }}>
            {highlights.map((h) => (
              <div key={h} className="flex items-center gap-2 text-blue-50">
                <CheckCircle2 size={18} className="text-[#ff6b70] shrink-0" />
                <span className="text-sm font-medium">{h}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
